module.exports = __webpack_public_path__ + "img/12.0bbee2c2.png";